import { easeOut, easeIn } from './timingFunctions';
var slideAnimations = {
  // Slides object down to original position
  slideDownEnterFast: {
    keyframe: function keyframe(_ref) {
      var distance = _ref.distance;
      return {
        '0%': {
          transform: "translateY(-".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateY(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from top to bottom
  slideDownEnterMedium: {
    keyframe: function keyframe(_ref2) {
      var distance = _ref2.distance;
      return {
        '0%': {
          transform: "translateY(-".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateY(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from top to bottom
  slideDownEnterSlow: {
    keyframe: function keyframe(_ref3) {
      var distance = _ref3.distance;
      return {
        '0%': {
          transform: "translateY(-".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateY(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '700ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from top to bottom
  slideUpEnterFast: {
    keyframe: function keyframe(_ref4) {
      var distance = _ref4.distance;
      return {
        '0%': {
          transform: "translateY(".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateY(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from down to up
  slideUpEnterMedium: {
    keyframe: function keyframe(_ref5) {
      var distance = _ref5.distance;
      return {
        '0%': {
          transform: "translateY(".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateY(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from bottom to top
  slideUpEnterSlow: {
    keyframe: function keyframe(_ref6) {
      var distance = _ref6.distance;
      return {
        '0%': {
          transform: "translateY(".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateY(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '700ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // ---Horizontal Slide Animations---- //
  // Slides object in from right to left
  slideLeftEnterFast: {
    keyframe: function keyframe(_ref7) {
      var distance = _ref7.distance;
      return {
        '0%': {
          transform: "translateX(".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateX(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from right to left
  slideLeftEnterMedium: {
    keyframe: function keyframe(_ref8) {
      var distance = _ref8.distance;
      return {
        '0%': {
          transform: "translateX(".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateX(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from right to left
  slideLeftEnterSlow: {
    keyframe: function keyframe(_ref9) {
      var distance = _ref9.distance;
      return {
        '0%': {
          transform: "translateX(".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateX(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '700ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from left to right
  slideRightEnterFast: {
    keyframe: function keyframe(_ref10) {
      var distance = _ref10.distance;
      return {
        '0%': {
          transform: "translateX(-".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateX(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from left to right
  SlideRightEnterMedium: {
    keyframe: function keyframe(_ref11) {
      var distance = _ref11.distance;
      return {
        '0%': {
          transform: "translateX(-".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateX(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slides object in from left to right
  slideRightEnterSlow: {
    keyframe: function keyframe(_ref12) {
      var distance = _ref12.distance;
      return {
        '0%': {
          transform: "translateX(-".concat(distance, ")"),
          opacity: 0
        },
        '100%': {
          transform: 'translateX(0px)',
          opacity: 1
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '700ms',
    timingFunction: easeOut,
    direction: 'forward',
    fillMode: 'forwards'
  },
  // Slide Exit Animation///
  slideDownExitFast: {
    keyframe: function keyframe(_ref13) {
      var distance = _ref13.distance;
      return {
        '0%': {
          transform: 'translateY(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateY(".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideDownExitMedium: {
    keyframe: function keyframe(_ref14) {
      var distance = _ref14.distance;
      return {
        '0%': {
          transform: 'translateY(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateY(".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideDownExitSlow: {
    keyframe: function keyframe(_ref15) {
      var distance = _ref15.distance;
      return {
        '0%': {
          transform: 'translateY(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateY(".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideUpExitFast: {
    keyframe: function keyframe(_ref16) {
      var distance = _ref16.distance;
      return {
        '0%': {
          transform: 'translateY(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateY(-".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '300ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideUpExitMedium: {
    keyframe: function keyframe(_ref17) {
      var distance = _ref17.distance;
      return {
        '0%': {
          transform: 'translateY(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateY(-".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideUpExitSlow: {
    keyframe: function keyframe(_ref18) {
      var distance = _ref18.distance;
      return {
        '0%': {
          transform: 'translateY(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateY(-".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideRightExitFast: {
    keyframe: function keyframe(_ref19) {
      var distance = _ref19.distance;
      return {
        '0%': {
          transform: 'translateX(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateX(".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '300ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideRightExitMedium: {
    keyframe: function keyframe(_ref20) {
      var distance = _ref20.distance;
      return {
        '0%': {
          transform: 'translateX(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateX(".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideRightExitSlow: {
    keyframe: function keyframe(_ref21) {
      var distance = _ref21.distance;
      return {
        '0%': {
          transform: 'translateX(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateX(".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideLeftExitFast: {
    keyframe: function keyframe(_ref22) {
      var distance = _ref22.distance;
      return {
        '0%': {
          transform: 'translateX(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateX(-".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '300ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideLeftExitMedium: {
    keyframe: function keyframe(_ref23) {
      var distance = _ref23.distance;
      return {
        '0%': {
          transform: 'translateX(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateX(-".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '400ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  },
  slideLeftExitSlow: {
    keyframe: function keyframe(_ref24) {
      var distance = _ref24.distance;
      return {
        '0%': {
          transform: 'translateX(0px)',
          opacity: 1
        },
        '100%': {
          transform: "translateX(-".concat(distance, ")"),
          opacity: 0
        }
      };
    },
    keyframeParams: {
      distance: '20px'
    },
    duration: '500ms',
    timingFunction: easeIn,
    direction: 'forward',
    fillMode: 'forwards'
  }
};
export default slideAnimations;